import {
  Sparkles,
  PlugZap,
  BarChart3,
  Target,
  ShieldCheck,
} from "lucide-react";

/**
 * ساختار Bento:
 *   کل گرید ۶ ستونه (دسکتاپ)
 *   featured  → span 3 (نصف)
 *   md        → span 3
 *   sm        → span 2
 *
 * چیدمان نهایی (ردیف اول):  featured (3) + md (3)
 * ردیف دوم:                  md (2) + sm (2) + sm (2)
 */
export const FEATURES = [
  {
    key: "ai",
    Icon: Sparkles,
    span: "lg:col-span-3",
    tone: "teal-strong",
    featured: true,
    hasArrow: true,
  },
  {
    key: "connect",
    Icon: PlugZap,
    span: "lg:col-span-3",
    tone: "teal",
  },
  {
    key: "dashboard",
    Icon: BarChart3,
    span: "lg:col-span-2",
    tone: "gold",
  },
  {
    key: "sales",
    Icon: Target,
    span: "lg:col-span-2",
    tone: "pink",
  },
  {
    key: "security",
    Icon: ShieldCheck,
    span: "lg:col-span-2",
    tone: "teal",
  },
];